<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
//import axios from 'axios';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
//import { fetchAverageRemainingStock } from '@/api/api.js';

function hexToRgb(hex) {
  const bigint = parseInt(hex.substring(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
}

function rgbToRgba(r, g, b, a = 0.7) {
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

function generateRandomColorInRange(startColor, endColor) {
  const startRGB = hexToRgb(startColor);
  const endRGB = hexToRgb(endColor);

  const r = Math.floor(Math.random() * (endRGB[0] - startRGB[0] + 1)) + startRGB[0];
  const g = Math.floor(Math.random() * (endRGB[1] - startRGB[1] + 1)) + startRGB[1];
  const b = Math.floor(Math.random() * (endRGB[2] - startRGB[2] + 1)) + startRGB[2];

  return rgbToRgba(r, g, b);
}

function generateRandomColorsInRange(startColor, endColor, numColors) {
  const colors = [];
  for (let i = 0; i < numColors; i++) {
    colors.push(generateRandomColorInRange(startColor, endColor));
  }
  return colors;
}

// Generate random colors in the range 4f4646 to c6c0c0
const startColor = "#4f4646";
const endColor = "#c6c0c0";
const numColors = 100;
const colors = generateRandomColorsInRange(startColor, endColor, numColors);

const options = {
  responsive: true,
  maintainAspectRatio: true,
  tooltips: {
    enabled: false,
    custom: CustomTooltips,
    intersect: true,
    mode: 'index',
    position: 'nearest',
    callbacks: {
      labelColor: function (tooltipItem, chart) {
        return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
      }
    }
  },
  legend: {
    display: false // 범례를 완전히 숨김
  },
  scales: {
    xAxes: [{
      gridLines: {
        color: 'rgba(0, 0, 0, 0.1)'
      },
      ticks: {
        fontColor: '#000',
        fontSize: 11
      }
    }],
    yAxes: [{
      gridLines: {
        color: 'rgba(0, 0, 0, 0.1)'
      },
      ticks: {
        fontColor: '#000',
        fontSize: 11,
        beginAtZero: true
      }
    }]
  },
  elements: {
    rectangle: {
      borderSkipped: 'bottom'
    }
  }
};

export default {
  name: 'BarChart',
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, options);
  },
  watch: {
    chartData(newVal) {
      if (newVal && newVal.labels && newVal.datasets) {
        // 데이터셋을 labels에 맞게 배열화
        const datasetValues = newVal.labels.map(label => {
          const dataset = newVal.datasets.find(ds => ds.label === label);
          return dataset ? dataset.data[0] : 0;
        });

        const updateData = {
          labels: newVal.labels,
          datasets: [{
            data: datasetValues, // label 속성을 제거
            backgroundColor: newVal.labels.map((_, index) => colors[index % colors.length]),
            borderColor: newVal.labels.map((_, index) => colors[index % colors.length]),
            borderWidth: 1,
            tension: 0.4
          }]
        };

        this.renderChart(updateData, options);
      } else {
        console.error("Invalid chart data format:", newVal);
      }
    }
  }
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 50%;
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
